export default __webpack_public_path__ + "static/media/background.3a4d3527.jpg";